var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownNoBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.012 4.979L5.512 0l-5.5 4.979v2.425l3.344-3.17c.396-.383.902-.872 1.298-1.277-.022.915-.022 1.32-.022 1.745V15h1.76V4.702c0-.425 0-.85-.022-1.745.396.405.836.894 1.232 1.256l3.41 3.191V4.98z"
  })));
}
export default SvgArrowDownNoBorder;